<template>
    <div ref="sellsyAcademy" class="slider-item slider-item--sellsy-academy">
        <div class="slider-item__avatar">
            <img
                ref="avatar"
                src="/ressources/logged/img/illustrations/recap2024/avatar-recap.svg"
                width="108"
            />
        </div>
        <p v-for="item in text" :key="item" class="slider-item__text">
            {{ item }}
        </p>
        <div ref="actionButton" class="slider-item__button">
            <CompassButton
                :label="$t.__('recap.slider.SellsyAcademySlide.button')"
                @click="handleClick"
            />
        </div>
    </div>
</template>
<script>
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
import Splitting from 'splitting';
import anime from 'animejs';

export default {
    name: 'SellsyAcademySlide',
    props: {
        text: {
            type: Array,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline({
                    delay: 300,
                });

                animatedTimeline
                    .add({
                        targets: this.$refs.avatar,
                        scale: [0, 1],
                        opacity: [0, 1],
                    })
                    .add(
                        {
                            targets: this.$refs.sellsyAcademy.querySelectorAll('.word'),
                            translateY: [40, 0],
                            opacity: [0, 1],
                            delay: anime.stagger(50),
                        },
                        '-=600',
                    )
                    .add(
                        {
                            targets: this.$refs.actionButton,
                            opacity: [0, 1],
                            duration: 500,
                        },
                        '-=900',
                    );
            } else {
                this.$refs.avatar.removeAttribute('style');
                this.$refs.actionButton.removeAttribute('style');
                const items = this.$refs.sellsyAcademy.querySelectorAll('.word');

                for (const item of items) {
                    item.removeAttribute('style');
                }
            }
        },
    },
    mounted() {
        Splitting({ target: this.$refs.sellsyAcademy.querySelectorAll('p'), by: 'words' });
    },
    methods: {
        handleClick() {
            window.open(this.url, '_blank');
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    gap: 27px;

    &__text {
        color: #7f95fe;
        font-family: Patron, sans-serif;
        font-size: 20px;
        line-height: 26px;
        margin: 0;
        text-align: center;
    }

    &__avatar {
        img {
            margin-left: 23px;
            opacity: 0;
        }
    }

    &__button {
        opacity: 0;
    }
}
</style>
